import * as zod from 'zod';

import type { DeviceState } from '@sb/integrations/types';
import type { CustomEquipmentSensorConfiguration } from '@sb/integrations/types/customEquipmentTypes';

import type { KinematicState } from '../../RoutineRunnerState';

import type { SpaceExpression } from './SpaceExpressionTypes';

export const JavaScriptExpression = zod.object({
  kind: zod.literal('JavaScript'),
  expression: zod.string(),
  errorMessage: zod.string().optional().nullable(),
});

export type JavaScriptExpression = zod.infer<typeof JavaScriptExpression>;

export type JSRunner = {
  evaluate(args: {
    expression: string;
    context: {
      kinematicState: {
        ioState: KinematicState['ioState'];
        gripperState: DeviceState | undefined;
      };
      variables: Record<string, any>;
      routine: {
        positionLists: Record<string, SpaceExpression>;
      };
      sensors: Record<string, CustomEquipmentSensorConfiguration>;
    };
  }): Promise<unknown>;
};
